import React, {Component} from "react";
import "bootstrap";
import {Route, Switch} from "react-router-dom";
import queryString from "query-string";
import ViewPerson from "../AboutMe/ViewPerson";
import Vacation from "../Vacation/Vacation";
import DayOff from "../DayOff/DayOff";
import MatHelp from "../MatHelp/MatHelp";
import AccessMatrix from "../AccessMatrix/AccessMatrix";
import WorkDocuments from "../WorkDocuments/WorkDocuments";
import PrivateDocuments from "../PrivateDocuments1/PrivateDocuments";
import SubVacation from "../ManagerOffice/SubVacation/SubVacation";
import SubEducation from "../ManagerOffice/SubEducation/SubEducation";
import SubMedicalPolicy from "../ManagerOffice/SubMedicalPolicy/SubMedicalPolicy";
import SubOfficialDocuments from "../ManagerOffice/SubOfficialDocuments/SubOfficialDocuments";
import SubDayOff from "../ManagerOffice/SubDayOff/SubDayOff";
import PersonalStage from "../ManagerOffice/PersonalStage/PersonalStage";
import SubAccessMatrix from "../ManagerOffice/SubAccessMatrix/SubAccessMatrix";
import DailyChart from "../ManagerOffice/DailyChart/DailyChart";
import SubSchedule from "../ManagerOffice/SubSchedule/SubSchedule";
import WorkingHours from "../ManagerOffice/WorkingHours/WorkingHours";
import SubScheduleChangeRequests from "../ManagerOffice/SubSchedule/ChangeRequest/ScheduleChangeRequestList";
import ConfidentialInformation from "../ManagerOffice/ConfidentialInformation/ConfidentialInformation";
import PeopleBoard from "../ManagerOffice/PeopleBoard/PeopleBoard";
import Sandbox from "../Sandbox/Sandbox";
import SMSAuthenticator from "../security/SMSAuthenticator";
import TestReport from "../Sandbox/TestReport";
import ExternalLinks from "../ExternalLinks/ExternalLinks";
import RvdRequestList from "../RVD/RvdRequestList";
import EDDocList from "../Docflow/EDDocList";
import Claim from "../Claim/Claim";
import PaySlipRouter from "../PaySlip/PaySlipRouter";
import Acquaintance_LNA from "../SelfService/Acquaintance_LNA";
import PropTypes from "prop-types";
import SelfService from "../SelfService/SelfService";
import DayOff2 from "../DayOff/DayOff2";
import AgreementList from "../Docflow/AgreementList";
import SubScheduleVacation from "../ManagerOffice/SubVacation/SubScheduleVacation";
import YearBonus from "../YearBonus/YearBonus";
import ScheduleVacation from "../Vacation/ScheduleVacation";
import SubBenefits from "../ManagerOffice/SubBenefits/SubBenefits";
import OrgChart from "../OrgChart/OrgChart";
import SoutCards from "../SoutCards/SoutCards";
import References from "../References/References";
import References1 from "../References1/References1";
import SubPositionResponsibilities from "../ManagerOffice/SubPositionResponsibilities/SubPositionResponsibilities";
import AnnualRemuneration from "../AnnualRemuneration/AnnualRemuneration";
import Anchor from "../Sandbox/Anchor";
import {CommandContext} from "@mnjsplatform/data";
import PageWrapper from "./PageWrapper";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import IllnessList from "../Docflow/IllnessList";
import SalaryRequestList from "../SalaryProject/SalaryRequestList";
import SubRequestScheduleVacationList from "../ManagerOffice/SubVacation/SubRequestScheduleVacationList";
import WorkSchedule from "../WorkSchedule/WorkSchedule";
import SubFinanceEmail from "../ManagerOffice/FinanceEmail/SubFinanceEmail";
import SignTimeSheet from "../ManagerOffice/SignTimeSheet/SignTimeSheet";
import SubRemoteWork from "../ManagerOffice/SubRemoteWork/SubRemoteWork";
import AboutInfo from "../SelfService/AboutInfo";

export const commandToRouteMap = {
    Profile: {link: "Profile", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><ViewPerson commandId={id} /></>}
};

export const formObjectToRouteMap = {
    About: {link: "AboutMe", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><ViewPerson commandId={id}/></>},
    AnnualRemuneration: {link: "AnnualRemuneration", render: (id) => <SMSAuthenticator><AnnualRemuneration commandId={id}/></SMSAuthenticator>},
    Vacation: {link: "Vacation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><Vacation commandId={id}/></>},
    DayOff: {link: "DayOff", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><DayOff commandId={id}/></>},
    PrivateDocuments: {link: "PrivateDocuments", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><PrivateDocuments commandId={id}/></>},
    MatHelp: {link: "MatHelp", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><MatHelp commandId={id}/></>},
    WorkDocuments: {link: "WorkDocuments", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><WorkDocuments commandId={id}/></>},
    PaySlip: {link: "PaySlip", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SMSAuthenticator><PaySlipRouter commandId={id}/></SMSAuthenticator></>},
    AccessMatrix: {link: "AccessMatrix", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><AccessMatrix commandId={id}/></>},
    PersonalStage: {link: "PersonalStage", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><PersonalStage commandId={id}/></>},
    SubVacation: {link: "SubVacation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubVacation commandId={id}/></>},
    SubEducation: {link: "SubEducation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubEducation commandId={id}/></>},
    SubMedicalPolicy: {link: "SubMedicalPolicy", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubMedicalPolicy commandId={id}/></>},
    SubOfficialDocuments: {link: "SubOfficialDocuments", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubOfficialDocuments commandId={id}/></>},
    SubDayOff: {link: "SubDayOff", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubDayOff commandId={id} /></>},
    SubAccessMatrix: {link: "SubAccessMatrix", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubAccessMatrix commandId={id}/></>},
    DailyChart: {link: "DailyChart", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><DailyChart commandId={id}/></>},
    SubSchedule: {link: "SubSchedule", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubSchedule commandId={id}/></>},
    WorkingHours: {link: "WorkingHours", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><WorkingHours commandId={id}/></>},
    SubScheduleChange: {link: "SubScheduleChange", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubScheduleChangeRequests commandId={id}/></>},
    ConfidentialInformation: {link: "ConfidentialInformation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SMSAuthenticator><ConfidentialInformation commandId={id}/></SMSAuthenticator></>},
    PeopleBoard: {link: "PeopleBoard", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><PeopleBoard commandId={id}/></>},
    ExternalLinks: {link: "ExternalLinks", render: (id) => <ExternalLinks commandId={id}/>},
    RvdRequestList: {link: "RvdRequestList", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><RvdRequestList commandId={id} type="PrivateOffice"/></>},
    RvdSubRequestList: {link: "RvdSubRequestList", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><RvdRequestList commandId={id} type="ManagerOffice"/></>},
    EDDocList: {link: "Docflow", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><EDDocList commandId={id}/></>},
    Claim: {link: "Claim", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><Claim commandId={id} TypeClaimViewIntId={1}/></>},
    ReceiveSysDoc: {link: "Acquaintance_LNA", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><Acquaintance_LNA commandId={id}/></>},
    SelfService: {link: "SelfService", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SelfService commandId={id}/></>},
    AboutInfo: {link: "AboutInfo", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><AboutInfo commandId={id}/></>},
    DayOff2: {link: "DayOff2", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><DayOff2 commandId={id}/></>},
    AgreementList: {link: "AgreementList", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><AgreementList commandId={id}/></>},
    SubScheduleVacation: {link: "SubScheduleVacation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubScheduleVacation commandId={id}/></>},
    YearBonus: {link: "YearBonus", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><YearBonus commandId={id}/></>},
    ScheduleVacation: {link: "ScheduleVacation", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><ScheduleVacation commandId={id}/></>},
    SubBenefits: {link: "SubBenefits", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubBenefits commandId={id}/></>},
    OrgChart: {link: "OrgChart", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><OrgChart commandId={id}/></>},
    SoutCards: {link: "SoutCards", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SoutCards commandId={id}/></>},
    References: {link: "References", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><References commandId={id}/></>},
    SubPositionResponsibilities: {link: "SubPositionResponsibilities", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubPositionResponsibilities commandId={id}/></>},
    References1: {link: "References1", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><References1 commandId={id}/></>},
    RequestTrip: {link: "RequestTrip", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><Claim commandId={id} TypeClaimViewIntId={2}/></>},
    IllnessList: {link: "IllnessList", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><IllnessList commandId={id} /></>},
    SalaryProject: {link: "SalaryProject", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SalaryRequestList commandId={id} collapsed={false}/></>},
    SubRequestScheduleVacationList: {link: "SubRequestScheduleVacationList", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubRequestScheduleVacationList commandId={id} /></>},
    WorkSchedule: {link: "WorkSchedule", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><WorkSchedule commandId={id}/></>},
    SalaryChangeEmail: {link: "SalaryChangeEmail", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubFinanceEmail commandId={id} controller="SalaryChangeEmail"/></>},
    AnnualBonusEmail: {link: "AnnualBonusEmail", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubFinanceEmail commandId={id} controller="AnnualBonusEmail"/></>},
    SignTimeSheet: {link: "SignTimeSheet", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SignTimeSheet commandId={id} /></>},
    SubRemoteWork: {link: "SubRemoteWork", render: (id) => <><PlaceholderWrapper commandInstruction={true}/><SubRemoteWork commandId={id} /></>}
};

export function getUrlByMenuItem(menuItem, commandParams) {

    if (!(menuItem && menuItem.AppCommand && menuItem.AppCommand.Param1))
        return "";

    const objectName = menuItem.AppCommand.Param1;

    const target = formObjectToRouteMap[objectName];
    if (!target)
        return "";

    const qs = queryString.stringify(commandParams);

    return "/" + target.link + "?" + qs;
}

export function navigateCommand(history, commandName, commandParams) {

    const target = commandToRouteMap[commandName];
    if (!target)
        return;

    const qs = queryString.stringify(commandParams);

    history.push("/" + target.link + "?" + qs);
}

export function navigateToForm(history, formName, commandParams) {

    const target = formObjectToRouteMap[formName];
    if (!target)
        return;

    let hash = "";
    let qs;
    if(commandParams) {
        if (commandParams.hash) {
            hash = "#" + commandParams.hash;
            delete commandParams.hash;
        }
        qs = queryString.stringify(commandParams);
    }
    history.push("/" + target.link + (qs && qs.length > 0 ? "?" + qs : "") + hash);
}

class Routes extends Component {

    componentWillUnmount() {
        console.log("router unmount");
    }

    render() {
        const wp = this.props.workplaceId;
        let root;
        if (wp !== "PrivateAreaReceive") {
            root = <CommandContext.Provider value={{key: "About", workplaceId: wp}}><PageWrapper>
                    <PlaceholderWrapper commandInstruction={true}/>
                    <ViewPerson/>
                </PageWrapper>
            </CommandContext.Provider>;
        } else {
            root = <CommandContext.Provider
                value={{key: "AboutInfo", workplaceId: wp}}><PageWrapper><PlaceholderWrapper
                commandInstruction={true}/><AboutInfo/></PageWrapper></CommandContext.Provider>;
        }

        return (
            <Switch>
                <Route path="/">
                    <React.Fragment>
                        <Route path="/" exact render={() => root}/>
                        <Route path="/sandbox" render={() => <SMSAuthenticator><Sandbox/></SMSAuthenticator>}/>
                        <Route path="/TestReport" render={() => <TestReport/>}/>
                        <Route path="/Anchor" render={() => <Anchor/>}/>
                        {
                            Object.entries(commandToRouteMap)
                                .map(([key, value]) => <Route path={"/" + value.link} key={key} render={function () {
                                    return <CommandContext.Provider value={{key: key, workplaceId: wp}}><PageWrapper>{value.render(key, wp)}</PageWrapper></CommandContext.Provider>
                                }}/>)
                        }
                        {
                            Object.entries(formObjectToRouteMap)
                                .map(([key, value]) => <Route path={"/" + value.link} key={key} render={function () {
                                    //return value.render(key, wp)
                                    //console.log(`commandId: ${key}`);
                                    return <CommandContext.Provider value={{key: key, workplaceId: wp}}><PageWrapper>{value.render(key, wp)}</PageWrapper></CommandContext.Provider>
                                }}/>)
                        }
                    </React.Fragment>
                </Route>
            </Switch>
        );
    }
}

Routes.propTypes = {
    workplaceId: PropTypes.string
};

Routes.defaultProps = {
    workplaceId: "default"
};

export default Routes;